import {Button, Dropdown, Input, DropdownMenu, Icon} from "semantic-ui-react";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import React, {
    useEffect,
    useState,
} from "react";

import styles from "../SearchBar.module.scss";
import {useWorkPackagesSelector} from "../../../../../store/selectors/work-packages.selectors";
import {useDispatch} from "react-redux";
import * as searchActions from "../../../../../store/actions/search.actions";
import {useSearchParamatersSelector} from "../../../../../store/selectors/search.selectors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useActiveProjectSelector} from "../../../../../store/selectors/project.selectors";
import classNames from "classnames";

export const ReportDropdown: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const workPackages = useWorkPackagesSelector();
  const dispatch = useDispatch();
  const searchParams = useSearchParamatersSelector();
  const activeProject = useActiveProjectSelector();

  // need to close the dropdown on click outside of the dropdown
    useEffect(() => {
        // Add event listener to close the dropdown when clicking outside
        const handleClickOutside = (event: MouseEvent) => {
            const dropdownElement = document.getElementById("reports-dropdown");
            if (dropdownElement && !dropdownElement.contains(event.target as Node)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

  return (
      <Dropdown
          className='work-package-dropdown'
          id="reports-dropdown"
          open={isDropdownOpen}
          icon={
            <div className={styles.FilterIcon}>
              <Button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  circular
                  disabled={!activeProject}
                  active={false}
                  size="tiny"
              >
                {searchParams.workPackage ? searchParams.workPackage.workPackageRef : "WP"}
                  {searchParams.workPackage && searchParams.workPackage.workPackageRef && <FontAwesomeIcon
                      style={{marginLeft: "7px"}}
                      icon={faClose}
                      onClick={(e) => {
                          e.stopPropagation()
                          dispatch(searchActions.SearchActions.setWorkPackage(null));
                          setIsDropdownOpen(false);
                      }}
                  />}
              </Button>
            </div>
          }>
        <DropdownMenu>
            <Dropdown.Header>Work Packages</Dropdown.Header>
            <Input
                icon='search'
                iconPosition='left'
                className='search'
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={(e: React.KeyboardEvent) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                }}
            />
          <DropdownMenu scrolling className={styles.dropdownMenuScrolling}>
          {workPackages.filter((wp) => (wp.workPackageRef + wp.workPackageName).toLowerCase().includes(searchText.toLowerCase())).map((wp) => (
            <Dropdown.Item
                onClick={() => {
                  dispatch(searchActions.SearchActions.setWorkPackage(wp));
                  setIsDropdownOpen(false);
                }}
                key={wp.workPackageId}>
              {wp.workPackageRef} - {wp.workPackageName}
            </Dropdown.Item>
          ))}
          </DropdownMenu>
        </DropdownMenu>
      </Dropdown>
  );
};
